// Single source of truth for lead status badge colours.
// Used by LeadStatusBadge and by the status tabs on My Leads.
export const STATUS_COLOR_MAP = {
  New: { bg: "#EEF2FF", fg: "#4F46E5" },
  Contacted: { bg: "#E0F2FE", fg: "#0284C7" },
  Qualified: { bg: "#F0FDF4", fg: "#16A34A" },
  "Demo Scheduled": { bg: "#FEF3C7", fg: "#CA8A04" },
  "Demo Completed": { bg: "#DCFCE7", fg: "#15803D" },
  Won: { bg: "#D1FAE5", fg: "#047857" },
  Lost: { bg: "#FEE2E2", fg: "#B91C1C" },
  "Demo Cancelled": { bg: "#FEE2E2", fg: "#B91C1C" },
};

// Neutral fallback for the "All" tab.
export const NEUTRAL_TAB_COLORS = { bg: "#E5E7EB", fg: "#0A1A4A" };